import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { SuperSEO } from "react-super-seo";
import PsContext from "../../context";
import { COLLEGE_UUID, DB_POSTFIX, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

import LoaderIcon from "../../utils/LoaderIcon";
import NotFound from "../notFound";
import Announcements from "../homePage/announcements";

const CustomPage = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  useEffect(() => {
    loadData();
  }, [props.match.params]);

  const loadData = () => {
    setLoader(true);
    axios
      .post(
        ServiceUrl.GET_PAGE +
          "?college_uuid=" +
          COLLEGE_UUID +
          "&slug=" +
          props.match.params.slug
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  const field = (fieldName) => dataList[fieldName] || "";

  return (
    <div style={{ minHeight: "350px" }}>
      {loader && <LoaderIcon />}

      {!loader && dataList.id && (
        <>
          <SuperSEO
            title={field("seo_meta_title") || field("title")}
            description={
              field("seo_seo_meta_description") ||
              context.settingValue("print_header_name")
            }
            lang="en"
          />
          {/* <section>
            <div className="head-2">
              <div className="container">
                <div className="head-2-inn head-2-inn-padd-top">
                  <h1>{upperCase(field("title"))}</h1>
                </div>
              </div>
            </div>
          </section> */}

          <section>
            <div className="container com-sp pad-bot-70 pg-inn ps_min_height px-5">
              <Row>
                <Col md={8}>
                  <h5
                    style={{
                      color: `${context.settingValue(
                        "web_site_header_textcolor"
                      )}`,
                    }}
                  >
                    {upperCase(field("title"))}
                  </h5>
                  <hr />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: context.isRegionalLanguage()
                        ? field("content_html_unicode") || field("content_html")
                        : field("content_html"),
                    }}
                  />
                </Col>
                <Col md={4}>
                  <Announcements />
                </Col>
              </Row>
            </div>
          </section>
        </>
      )}

      {!loader && !dataList.id && <NotFound />}
    </div>
  );
};

export default CustomPage;
